import {RouteInfo} from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [
  
  {
    id: 'applicationHeading',
    path: '',
    heading: false,
    title: 'Application',
    icon: 'fa-layers',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [
      {
        id: 'applications',
        path: '/applications',
        heading: false,
        title: 'Applications',
        icon: 'fa-file-text',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: []
      }
    ]
  },{
    id: 'loan',
    path: '',
    heading: false,
    title: 'Loan',
    icon: 'ti-layers',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [
      {
        id: 'loans',
        path: '/loans',
        heading: false,
        title: 'Loan',
        icon: 'fa-file-text-o',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: []
      }
    ]
  },{
    id: 'profile',
    path: '',
    heading: false,
    title: 'Profile',
    icon: 'fa-layers',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [
      {
        id: 'profile',
        path: '/profile',
        heading: false,
        title: 'Profile',
        icon: 'fa-user',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: []
      }
    ]
  }
];

